<div class="p-4 sm:p-6 rounded-lg min-h-[500px]">
  <div
    class="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 gap-3"
  >
    <h2 class="text-xl font-semibold text-gray-800">
      Representantes de la compañía
    </h2>
    <button
      (click)="openAddRepresentativeModal()"
      class="bg-primary cursor-pointer text-white px-4 py-2 rounded-md hover:bg-primary/90 transition flex items-center justify-center gap-2 text-sm w-full sm:w-auto"
    >
      <ng-icon name="heroPlus" size="18"></ng-icon>
      <span class="hidden sm:inline">Agregar representante</span>
    </button>
  </div>
  <app-loading
    *ngIf="isLoading"
    [text]="'Cargando miembros de la compañía...'"
  ></app-loading>
  <div
    *ngIf="!isLoading && representatives.length === 0"
    class="flex flex-col items-center justify-center py-20 text-gray-500"
  >
    <ng-icon name="heroUsers" size="35" class="mb-3 text-gray-400"></ng-icon>
    <p class="text-lg font-medium">No hay representantes registrados</p>
    <p class="text-sm">
      Agrega a un miembro del equipo para gestionar la cuenta.
    </p>
  </div>
  <div *ngIf="!isLoading && representatives.length > 0" class="space-y-4">
    <div
      class="hidden sm:grid sm:grid-cols-4 text-xs font-semibold text-gray-600 border-b pb-2 px-2"
    >
      <span class="sm:col-span-2">Nombres</span>
      <span class="hidden sm:inline sm:col-span-1">Correo electrónico</span>
      <span class="text-right sm:col-span-1">Acciones</span>
    </div>
    <div
      *ngFor="let user of representatives"
      class="bg-gray-50 p-3 rounded-lg border border-gray-100 flex flex-col sm:grid sm:grid-cols-4 sm:items-center gap-3"
    >
      <div class="flex items-center gap-4 sm:col-span-2 min-w-0">
        <img
          [src]="getUserImage(user)"
          [alt]="'Foto de ' + user.firstName + ' ' + user.lastName"
          class="w-10 h-10 rounded-full object-cover shrink-0"
        />
        <div class="min-w-0 flex-1">
          <p class="font-medium text-sm text-gray-800 truncate">
            {{ user.firstName }} {{ user.lastName }}
          </p>
          <p class="text-xs text-gray-500 truncate sm:hidden">
            {{ user.email }}
          </p>
        </div>
      </div>
      <div
        class="hidden sm:flex sm:col-span-1 text-sm text-gray-700 items-center min-w-0 truncate px-2"
      >
        {{ user.email }}
      </div>
      <div
        class="flex justify-start sm:justify-end items-center gap-2 sm:col-span-1"
      >
        @if(userSession?.idUser !== user.id) {
        <button
          (click)="removeRepresentative(user.id)"
          class="px-3 py-1 cursor-pointer border border-red-400 text-red-600 text-xs rounded-md hover:bg-red-50 transition flex items-center gap-1"
        >
          <ng-icon name="heroTrash" size="14"></ng-icon>
          <span class="inline">Quitar</span>
        </button>
        }
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="modalAddRepresentative"
  class="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
>
  <div class="bg-white rounded-lg shadow-2xl max-w-lg w-full p-6 relative">
    <button
      (click)="closeAddRepresentativeModal()"
      class="absolute top-3 right-3 text-gray-500 hover:text-red-500 transition cursor-pointer"
      [disabled]="isAdding"
    >
      <ng-icon name="heroXMark" size="24"></ng-icon>
    </button>
    <h3 class="text-xl font-semibold text-gray-800 mb-4">
      Buscar y agregar representante
    </h3>
    <p class="text-sm text-gray-600 mb-5">
      Busque un usuario por su correo electrónico.
    </p>
    <div class="mb-4">
      <input
        type="email"
        [formControl]="searchControl"
        placeholder="Buscar por correo electrónico del usuario"
        class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition"
      />
      <div
        *ngIf="searchControl.invalid && searchControl.value"
        class="text-red-500 text-xs mt-1"
      >
        Ingrese un correo válido para buscar.
      </div>
    </div>
    <div class="min-h-[50px]">
      <app-loading
        *ngIf="isSearching"
        [text]="'Buscando usuarios...'"
        [size]="50"
      ></app-loading>
      <div
        *ngIf="!isSearching && searchResults.length > 0"
        class="max-h-64 overflow-y-auto space-y-2 border border-gray-200 rounded-md p-2"
      >
        <div
          *ngFor="let user of searchResults"
          class="flex items-center justify-between p-2 rounded-lg transition"
          [ngClass]="{
            'bg-gray-100/50 hover:bg-gray-100': !isAdding,
            'opacity-60 cursor-not-allowed': isAdding
          }"
        >
          <div class="flex items-center gap-3 min-w-0">
            <img
              [src]="getUserImage(user)"
              alt="Foto"
              class="w-8 h-8 rounded-full object-cover shrink-0"
            />
            <div class="min-w-0">
              <p class="font-medium text-sm text-gray-800 truncate">
                {{ user.firstName }} {{ user.lastName }}
              </p>
              <p class="text-xs text-gray-500 truncate">{{ user.email }}</p>
            </div>
          </div>
          <button
            (click)="addRepresentativeInline(user); $event.stopPropagation()"
            [disabled]="isAdding"
            class="p-1 rounded-full hover:bg-primary/10 transition"
          >
            <div
              class="text-primary h-8 w-8 flex items-center justify-center hover:text-primary-dark transition cursor-pointer shrink-0"
            >
              <div
                *ngIf="isAdding && selectedUserToAdd?.id === user.id"
                class="rounded-full animate-spin border-t-transparent text-primary"
                [ngStyle]="{
                  'width.px': 8,
                  'height.px': 8,
                  'border-width.px': 1
                }"
              ></div>
              <ng-icon
                *ngIf="!isAdding || selectedUserToAdd?.id !== user.id"
                name="heroPlusCircle"
                size="24"
              />
            </div>
          </button>
        </div>
      </div>
      <p
        *ngIf="
          !isSearching && searchControl.value && searchResults.length === 0
        "
        class="text-sm text-gray-500 text-center py-4"
      >
        No se encontraron usuarios con ese correo.
      </p>
    </div>
    <div class="flex justify-end mt-6">
      <button
        type="button"
        (click)="closeAddRepresentativeModal()"
        class="px-4 py-2 bg-gray-200 text-gray-700 rounded-md shadow hover:bg-gray-300 transition"
        [disabled]="isAdding"
      >
        Cerrar
      </button>
    </div>
  </div>
</div>
<div
  *ngIf="modalConfirmRemove"
  class="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
>
  <div class="bg-white rounded-lg shadow-2xl max-w-sm w-full p-6 relative">
    <div class="text-center mb-4">
      <ng-icon
        name="heroExclamationTriangle"
        size="48"
        class="text-red-500"
      ></ng-icon>
    </div>
    <h3 class="text-xl font-bold text-gray-800 text-center mb-2">
      Confirmar Eliminación
    </h3>
    <p class="text-sm text-gray-600 text-center mb-6">
      ¿Está seguro de que desea quitar a este usuario de esta compañía?
    </p>
    <div
      *ngIf="userToRemove"
      class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg mb-6 border border-gray-200"
    >
      <img
        [src]="getUserImage(userToRemove)"
        alt="Foto"
        class="w-10 h-10 rounded-full object-cover shrink-0"
      />
      <div>
        <p class="font-medium text-sm text-gray-700">
          {{ userToRemove.firstName }} {{ userToRemove.lastName }}
        </p>
        <p class="text-xs text-gray-500">{{ userToRemove.email }}</p>
      </div>
    </div>
    <div class="flex justify-end gap-3">
      <button
        type="button"
        (click)="closeConfirmRemoveModal()"
        class="px-4 py-2 bg-gray-200 text-gray-700 rounded-md shadow hover:bg-gray-300 transition"
        [disabled]="isRemoving"
      >
        Cancelar
      </button>
      <app-loading-button
        [text]="'Quitar'"
        [loading]="isRemoving"
        (click)="confirmRemoveRepresentative()"
      ></app-loading-button>
    </div>
  </div>
</div>
